import React from 'react';

import PropTypes from 'prop-types';
import { MdTerrain } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { ProgressButton, setSelectedActivity } from '../../../common';
import { datesShape } from '../../constants';
import { openCreateHike } from '../../duck';

class CreateHikeButton extends React.PureComponent {
  handleClick = () => {
    const { onOpenCreateHike, onClick } = this.props;
    onOpenCreateHike();
    if (onClick) {
      onClick();
    }
  };

  render() {
    const { title, disabled, className, children, replaceButton } = this.props;
    const button = replaceButton ? (
      React.cloneElement(replaceButton, { onClick: this.handleClick })
    ) : (
      <ProgressButton
        color="scouting-warm-gray"
        noBorder
        fitText
        title={title}
        disabled={disabled}
        icon={<MdTerrain />}
        className={className}
        onClick={this.handleClick}
      >
        {children || <FormattedMessage id="hikes.CreateHikeButton.label" />}
      </ProgressButton>
    );
    return button;
  }
}

CreateHikeButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  dates: datesShape,
  onClick: PropTypes.func,
  onOpenCreateHike: PropTypes.func.isRequired,
  replaceButton: PropTypes.node,
};

const mapDispatch = (
  dispatch,
  { dates, allowAddPersons, activityData, allowRemovePersons },
) => ({
  onOpenCreateHike: () => {
    dispatch(openCreateHike(dates, allowAddPersons, allowRemovePersons));
    activityData && dispatch(setSelectedActivity(activityData));
  },
});

export default connect(null, mapDispatch)(CreateHikeButton);
